import React, { Component } from "react";
import equal from "deep-equal";
import connectToMedia from "../../../Media/connectToMedia";

class AnimatorView extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    return !equal(nextProps, this.props);
  }

  innerStyleChanges() {
    let frame = this.props.frame >= 0 ? [this.props.frame] : [-100];
    if (this.props.queries) {
      const searchedQuery = this.props.queries.find((val) =>
        val.hits.map((item) => item.p).includes(frame[0])
      );
      if (searchedQuery) {
        const queryLength = searchedQuery.label.trim().split(" ").length;
        for (let i = 1; i < queryLength; i++) {
          frame.push(frame[0] + i);
        }
      }
    }
    return `
      ${frame.map((val) => `.word-index-${val}`).join(", ")} {
        background-color: rgba(170, 217, 187, 01);
        font-weight: bold;
        color: rgba(93,44,143,1);
      }

      .word-index-${frame[0] - 1},
      .word-index-${frame[frame.length - 1] + 1} {
        background-color: rgba(170, 217, 187, 0.666);
      }

      .word-index-${frame[0] - 2},
      .word-index-${frame[frame.length - 1] + 2} {
        background-color: rgba(170, 217, 187, 0.33);
      }

      .word-range-search {
        color: red;
        border-bottom: 1px solid black;
      }

      .word-range-true {
        font-weight: bold;
        color: rgba(93,44,143,1);
      }

      .chat-turn-highlighted {
        font-weight: bold;
        color: rgba(93,44,143,1);
      }

    `;
  }

  render() {
    return (
      <>
        <input value={this.props.frame} id="chat-frame-value" type="hidden"/>
        <style dangerouslySetInnerHTML={{ __html: this.innerStyleChanges() }} />
      </>
    );
  }
}

export default connectToMedia((state) => {
  return {
    queries: state.query,
  };
})(AnimatorView);
